import React from 'react';

export default () => <div className="ngh-AppBar--spacer"></div>